import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'

class CreateBloc {
    
    createChannel = new Subject()
    parentListChannel = new Subject()
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({ status: apiResponse.INITIAL })
        this.parentListChannel.next({ status: apiResponse.INITIAL })
    }

    fetchCreate = async (query) => {
        this.createChannel.next({ status: apiResponse.LOADING })
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({ status: apiResponse.COMPLETED, data: result })
        }).catch((error) => {
            this.createChannel.next({ status: apiResponse.ERROR, data: error })
        })
    }

    fetchParentList = async (query) => {
        this.parentListChannel.next({ status: apiResponse.LOADING })
        await this.repository.fetchParentList(query).then((result) => {
            this.parentListChannel.next({ status: apiResponse.COMPLETED, data: result })
        }).catch((error) => {
            this.parentListChannel.next({ status: apiResponse.ERROR, data: error })
        })
    }

}

export default CreateBloc